'use client';

import { isEmpty } from '@cat-ecom/common/utils/commonUtils';
import { Conditional, MyEquipmentSerialPrefix } from '@cat-ecom/pcc-components';
import { useTranslations } from 'next-intl';

export const EditEquipmentSerialPrefixSuggestions = ({
  suggestedPrefixes
}: {
  suggestedPrefixes: string;
}) => {
  const t = useTranslations();
  const showSuggestedPrefix = !isEmpty(suggestedPrefixes);

  return (
    <Conditional test={showSuggestedPrefix}>
      <MyEquipmentSerialPrefix
        prefixLabel={t('SUGGESTED_PREFIXES')}
        suggestions={suggestedPrefixes}
      />
    </Conditional>
  );
};
